import { render, staticRenderFns } from "./EditEmailTemplateDialog.vue?vue&type=template&id=6e854468&"
import script from "./EditEmailTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditEmailTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports